import React from "react";

export const IconHTML = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.881"
            height="12.13"
            viewBox="0 0 18.881 12.13"
        >
            <g id="code" transform="translate(-0.559 -4.735)">
                <path
                    id="Path_354"
                    data-name="Path 354"
                    d="M16,15.6l6-4.8L16,6"
                    transform="translate(-4)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <path
                    id="Path_355"
                    data-name="Path 355"
                    d="M8,6,2,10.8l6,4.8"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
};
